import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import LinkCell from '../Cells/LinkCell/LinkCell';
import ConnectionCell from '../Cells/ConnectionCell';
import DeviceLinkCell from '../Cells/LinkCell/DevicesLinkCall';
import { TrapTableTypeLink } from '../trapTables';

import { HubData } from 'api/traps/Hubs/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';
import { useEditHubModalStore } from 'pages/Traps/Modals/EditHubModal/EditHubModalStore';
import { useHubDeleteModalStore } from 'components/DeleteHubModal/HubsDeleteStore';

export const useHubsColumns = (slug: string): TableColumn<HubData>[] => {
  const { t } = useTranslation();
  const { onEditHubModalOpen } = useEditHubModalStore();
  const { openDeleteHubModal } = useHubDeleteModalStore();

  return [
    {
      name: <i className="ri-wifi-fill fs-16" />,
      selector: row => row.connection_status,
      sortable: true,
      sortField: 'connection_status',
      cell: row => <ConnectionCell status={row.connection_status} />,
      width: '75px',
    },
    {
      name: t('TrapTables.Number'),
      selector: row => row.sequence_number,
      sortable: true,
      sortField: 'sequence_number',
      cell: row => (
        <LinkCell
          title={String(row.sequence_number) || 'None'}
          link={`/hub/info/${row.slug}/`}
          icon="ri-eye-line"
          toReact
        />
      ),
      grow: 1,
    },
    {
      name: t('TrapTables.InteractiveMap'),
      selector: row => row.default_plan?.url_ending ?? '',
      cell: row => (
        <DeviceLinkCell
          data={row.default_plan}
          icon="ri-treasure-map-line"
          slug={slug}
          deviceType={TrapTableTypeLink.Hubs}
          device_add_slug={row.slug}
        />
      ),
      grow: 2,
      hide: Breakpoints.Mobile,
    },
    {
      name: t('TrapTables.DeviceConnected'),
      selector: row => row.traps_connected,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('TrapTables.LastConnection'),
      selector: row => (row?.last_connect ? dayjs(row.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-'),
      sortable: true,
      sortField: 'last_connection',
      hide: Breakpoints.Desktop,
    },
    {
      name: t('TrapTables.Action'),
      selector: row => row.default_plan?.on_plan ?? '',
      maxWidth: '70px',
      cell: row => (
        <div className="btn-group d-flex align-items-center justify-content-center" role="group">
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => onEditHubModalOpen(row.slug, { serialNumber: row.serial_number, pk: row.id })}
          >
            <i className="ri-pencil-fill icon icon__edit" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => openDeleteHubModal(row.serial_number, row.id, row.traps_connected)}
          >
            <i className="ri-delete-bin-6-fill icon icon__delete" />
          </button>
        </div>
      ),
    },
  ];
};
